import { InformDICompleted, InformDISelectItems } from '../components/inform-di-wizard';
import { ReportedFindingsMachineContext } from '../machine/context';

export function InformDIScreen() {
    ReportedFindingsMachineContext.useActorRef();

    const isSelectItems = ReportedFindingsMachineContext.useSelector(
        (state) => state.matches({ informDI: 'selectItems' })
            || state.matches({ informDI: 'informDIRequest' })
    );

    const isConfirmed = ReportedFindingsMachineContext.useSelector((state) => state.matches({ informDI: 'confirmed' }));

    return (
        <>
            {isSelectItems && <InformDISelectItems />}
            {isConfirmed && <InformDICompleted />}
        </>
    );
}
